import { IWorkspace } from "models/IWorkspace";

export interface IWorkspaceCardProps {
  workspace: IWorkspace;
  onEdit: (w: IWorkspace) => void;
  onArchive: (w: IWorkspace) => void;
  onUnarchive: (w: IWorkspace) => void;
  onLeave: (w: IWorkspace) => void;
  onDelete: (w: IWorkspace) => void;
  onSeeDetails: (w: IWorkspace) => void;
  onEnable: (w: IWorkspace) => void;
  onAddDocuments: (w: IWorkspace) => void;
  onAddMember: (w: IWorkspace) => void;
  isActive: boolean;
}

export const CARD_LABELS = {
  DESCRIPTION: "Description:",
  OWNERS: "Owners:",
  CREATED: "Created:",
  NOT_AVAILABLE: "N/A",
} as const;

export const MENU_LABELS = {
  DETAILS: "View Details",
  EDIT: "Edit Details",
  DELETE: "Delete",
  ARCHIVE: "Archive",
  UNARCHIVE: "Unarchive",
  LEAVE_WORKSPACE: "Leave Workspace",
  ADD_DOCUMENTS: "Add Documents",
  ADD_MEMBER: "Add Member",
} as const;

export const TOOLTIP_MESSAGES = {
  ACTIVE_CANT_DELETE: "Active workspace can't be deleted",
  ACTIVE_CANT_ARCHIVE: "Active workspace can't be archived",
  USE_WORKSPACE: "Use This Workspace",
  PERSONAL_WORKSPACE: "Personal Workspace - cannot be shared",
  COPY_DIRECT_LINK: "Copy Direct Link",
} as const;

export const WORKSPACE_CARD_CONSTANTS = {
  TOOLTIP_MAX_CHARS: 500,
} as const;

export const TOAST_MESSAGES = {
  LINK_COPIED: "Workspace link copied",
  LINK_COPY_FAILED: "Failed to copy workspace link",
} as const;
